import { VStack } from '@chakra-ui/layout'
import { Box, Text as ChakraText } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { GrImage as GrImageIcon } from 'react-icons/gr'
import { IoKeyOutline } from 'react-icons/io5'
import { TbWebhook } from 'react-icons/tb'
import styled, { createGlobalStyle } from 'styled-components'
import { colors } from '../../../ui-kit'
import { SideBar } from '../../layouts/Base'
import { SideBarItem } from '../../layouts/Base/SideBar'

const GrImage = styled(GrImageIcon)`
  path {
    stroke: ${props => props.stroke};
  }
`

const ActiveLinkStyles = createGlobalStyle`
  .active-link {
    ${GrImage} {
      path {
        stroke: ${colors.appSlate};
      }
    }

    :not(${GrImage}) {
      svg {
        fill: ${colors.appSlate};
      }
    }
    p {
      color: ${colors.appSlate};
    }
  }
`
const BillingSideMenu = (): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <SideBar heading={t('developer', 'Developer')}>
      <ActiveLinkStyles />
      <VStack
        overflow="auto"
        h="100%"
        spacing="1em"
        padding="1.5em 0.75em 1.5em"
      >
        <SideBarItem to="/developer/api-keys" activeClassName="active-link">
          <Box margin="1rem">
            <IoKeyOutline fontSize="2rem" color={colors.appBattleshipGrey} />
          </Box>
          <ChakraText
            fontSize="md"
            fontWeight="500"
            color="appBattleshipGrey"
            lineHeight="4rem"
          >
            {t('api_keys', 'API keys')}
          </ChakraText>
        </SideBarItem>
        <SideBarItem to="/developer/webhooks" activeClassName="active-link">
          <Box margin="1rem">
            <TbWebhook fontSize="2rem" color={colors.appBattleshipGrey} />
          </Box>
          <ChakraText
            fontSize="md"
            fontWeight="500"
            color="appBattleshipGrey"
            lineHeight="4rem"
          >
            {t('webhooks', 'Webhooks')}
          </ChakraText>
        </SideBarItem>
      </VStack>
    </SideBar>
  )
}

export default BillingSideMenu
